/**
 * Admin feature flags.
 *
 * ADMIN_AI_ENABLED — master switch for the OpenAI-backed helpers in the
 * admin (AI copywriter + AI banner art). Kept OFF pre-revenue: the app
 * runs fine without them (operators write copy and upload/choose art
 * themselves), and leaving them on only invites confusion and would tie
 * the platform to an OpenAI bill once a key is configured. Flip to `true`
 * (and set OPENAI_API_KEY on the Edge Functions) once the company decides
 * to pay for AI assistance.
 */
export const ADMIN_AI_ENABLED = false;
